/**
 *  EDAP events
 */

const actionlocation = 'property-types-module';

export const PROPERTY_TYPES_LINK_CLICK = ({ propertyTypeKey }) => ({
  name: 'search.link.click',
  data: {
    actionlocation,
    eventrefinements: propertyTypeKey
  }
});

export const PROPERTY_TYPES_CLICK_PREV = {
  name: 'navprev.click',
  data: {
    actionlocation
  }
};

export const PROPERTY_TYPES_CLICK_NEXT = {
  name: 'navnext.click',
  data: {
    actionlocation
  }
};

export const MODULE_VIEW_EVENT_OPTIONS = {
  actionlocation
};



// WEBPACK FOOTER //
// ./src/universal/components/PropertyTypes/events.js